import { Routes } from '@angular/router';
import { HomeComponent } from './home/feature/home.component';
import { eventsRoutes } from './routes/eventsRoutes';
import { aboutRoutes } from './routes/aboutRoutes';
import { authRoutes } from './routes/authRoutes';
import { userRoutes } from './routes/userRoutes';
import { errorRoutes } from './routes/errorRoutes';
import { eventSystemsRoutes } from './routes/eventSystemsRoutes';
import { adminRoutes } from './routes/adminRoutes';

export const routes: Routes = [
    { path: '', data: { sidebar: false }, component: HomeComponent },
    ...authRoutes,
    ...adminRoutes,
    ...eventsRoutes,
    ...aboutRoutes,
    ...userRoutes,
    ...eventSystemsRoutes,
    
    ...errorRoutes
];

